import React from "react";
import { GlobalContext } from "../../../../../utils/globalprovider";
import ToolsBar from "../../../../../components/bases/toolsbar/toolsbar";


import SubtitleSelectionMode from "./SubtitleRange/subtitleselectionmode";
import TimeCodeInput from "./timecodeinput/timecodeinput";

import { V2_ConvertTimeCodeStringToSecondFromAsset, V2_ConvertSecondToTimeCodeStringFromAsset,V2_getMaxFrameFromAsset } from "../../../../../utils/timecodev2";


import imgexit from "./assets/exit.png"
import imgaccept from "./assets/accept.png"

import "./submenus.css"


class Offset extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.state =
        {
            offset:0,
            libOffset: "+00:00:00:00",
            colorOffset: "white",
            errorLibs:(<></>),
            toolsbar : {
                height: 26,
                items: [
                    {img: imgexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                    {type:"space"},
                    {img: imgaccept ,type:"button", disable:false,fr:"Lancer",en:"Start", nochangecolor:false, key:{key:"START", cat:"actions"}},


                    ],
            },

        }


        this.tcref = React.createRef();
        this.newtcref = React.createRef();

        this.handleOnChangeTc = this.handleOnChangeTc.bind(this)
        this.handleOnChangeNewTc = this.handleOnChangeNewTc.bind(this)
        this.computeOffset = this.computeOffset.bind(this)


        this.selectionModeRef = React.createRef();
        this.onClickToolsBar = this.onClickToolsBar.bind(this);


        this.errorTc = false;
        this.errorNewTc = false;
        this.valueTc = 0;
        this.valueNewTc = 0;

    }


    componentDidUpdate(prevProps)
    {

        if (prevProps.current != this.props.current)
        {
            /*
            if ((this.props.current >=1) && (this.props.current <= this.props.subtitles.length))
                lasttcin = this.props.subtitles[this.props.current-1].tcin;
                
            var parameters = structuredClone(this.state.parameters);
            parameters.tcin  = lasttcin;
            this.setState({parameters: parameters});
            */
        }
    }


    onClickToolsBar(datas)
    {
        switch (datas.key)
        {
            case "START":
                if (this.props.onaction) 
                {
                    const ret = {
                        source: "parameters",
                        action:
                        {
                            
                            type: "offset",
                            parameters: {offset:this.state.offset},
                            range: this.selectionModeRef.current.getValues(),
                        }
                    };

                    
                    if (this.props.onaction) this.props.onaction (ret);
                }

                
                break;


            case "EXIT":
                if (this.props.onaction) this.props.onaction ({source:"submenu", submenu: {key:"EXIT"}});
                break;
        }
    }

    computeOffset()
    {
        



        if (this.errorTc || this.errorNewTc)
            this.setState ({offset:0,colorOffset:"red", libOffset:"--:--:--:--", errorLibs:(<></>)})
        else
        {
            const offset = this.valueNewTc - this.valueTc;
            var sign = "+";
            var libOffset = "?";

            if (offset > 0)
                libOffset = V2_ConvertSecondToTimeCodeStringFromAsset(offset,this.props.timecodeasset);
            else
            {
                sign="-";
                libOffset = V2_ConvertSecondToTimeCodeStringFromAsset(-offset,this.props.timecodeasset);
            }


            if ((this.selectionModeRef) && (this.selectionModeRef.current))
            {
                const values = this.selectionModeRef.current.getValues();
                console.log("range value", values)


                var donttest = false;
                const type = values.subtitles;
                var firstst=1;
                var lastst= this.props.subtitles.length;
                switch (type)
                {
                    case "current":
                        firstst = this.props.current;
                        lastst = this.props.current;
                        break;
                    case "range":
                        firstst = values.range.min;
                        lastst = values.range.max;
                        break;
                }
                if (firstst < 1) firstst=1;
                if (lastst > this.props.subtitles.length) lastst = this.props.subtitles.length;

                if ((lastst < 0) || (firstst < 0) || (firstst > this.props.subtitles.length) || (lastst > this.props.subtitles.length))
                    donttest = true;

                var errorLibs = (<></>)
                console.log("type", type,"st",firstst,"to",lastst,"don't test",donttest)
                if (!donttest)
                {
                    var errmin = false;
                    var errmax = false;

                    const minimaltimecode = 0;
                    const maximaltimecode = V2_ConvertTimeCodeStringToSecondFromAsset("23:59:59:29",this.props.timecodeasset)

                    var nust=firstst;
                    while ((nust <=lastst) && (!errmin || !errmax))
                    for (nust = firstst; nust <=lastst; nust++)
                    {
                        const subtitle = this.props.subtitles[nust-1];

                        var testst = true;
                        if ((type === "selected") && !subtitle.selected) testst=false;
                        if ((type === "unselected") && subtitle.selected) testst=false;

                        if (testst)
                        {
                            const newin = subtitle.in + offset;
                            const newout = subtitle.out + offset;

                            if (newin < minimaltimecode) errmin = true;
                            if (newout < minimaltimecode) errmin = true;
                            if (newin > maximaltimecode) errmax = true;
                            if (newout > maximaltimecode) errmax = true;

                        }

                        if (errmax && errmin) break;


                    }


                    var errorlibmin = (<></>);
                    var errorlibmax = (<></>);

                    if (errmin)
                    {
                        const errormintext = this.context.language=="fr"?"Certains sous-titres auront un time code à 00:00:00:00":"Some subtitles will have a timecode of 00:00:00:00";
                        errorlibmin = (<>{errormintext}</>)
                    }
                    if (errmax)
                    {
                        const errormaxtext = this.context.language=="fr"?"Certains sous-titres auront un time code supérieur à 24 heures":"Some subtitles will have a timecode exceeding 24 hours.";
                        if (errmin)
                            errorlibmax = (<><br/>{errormaxtext}</>)
                        else
                            errorlibmax = (<>{errormaxtext}</>)
                    }

                    errorLibs = (<div style ={{fontSize:"12px",
                            color:"orange",extAlign:"left",paddingRight:"10px",paddingLeft:"10px"}}>
                        {errorlibmin}{errorlibmax}
                        </div>);
            

                }

                


            }
            
            this.setState ({offset:offset,colorOffset:"white", libOffset:sign+libOffset,errorLibs:errorLibs})
        }


    }

    handleOnChangeTc(value,digit, valid)
    {
        
        this.valueTc =  V2_ConvertTimeCodeStringToSecondFromAsset(value, this.props.timecodeasset);
        this.errorTc = !valid;
        this.computeOffset();
    }
    handleOnChangeNewTc(value,digit, valid)
    {
        
        this.valueNewTc = V2_ConvertTimeCodeStringToSecondFromAsset(value, this.props.timecodeasset);
        this.errorNewTc = !valid;
        this.computeOffset();
    }

    render()
    {
        const title = this.context.language=="fr"?"Offset":"Offset";

        

        const maxframe = V2_getMaxFrameFromAsset(this.props.timecodeasset);
        

        const st  = this.props.current -1;
        var tc="00:00:00:00";
        var tcvalue = 0;
        if ((st >= 0) && (st< this.props.subtitles.length))
        {
            tc = V2_ConvertSecondToTimeCodeStringFromAsset(this.props.subtitles[st].in,this.props.timecodeasset);
            tcvalue = this.props.subtitles[st].in;
        }
        

        const newtc = V2_ConvertSecondToTimeCodeStringFromAsset(this.props.timecode,this.props.timecodeasset);


        return (
            <div className="submenuMain">
                <div className="submenuTitle">{title}</div>

                    <div className="submenuCurrentDiv">
                        {this.state.errorLibs}
                        <div style = {{
                            borderStyle:"solid",
                            paddingTop:"10px",
                            paddingBottom:"10px",
                            borderColor: "#202020",
                            borderRadius: "5px",
                            borderWidth:"1px",
                            marginTop:"10px",
                            marginBottom:"10px",
                            width:"98%"

                        }}>
                            <div style={{marginLeft: "90px",fontWeight:"bold", textAlign:"center", fontSize:"12px", textAlign:"left",color:"gray"}}>
                                {this.context.language=="fr"?"Ancien time code":"Old time code"}
                            </div>

                            <div 
                                style={{
                                    marginTop:"10px",
                                    marginBottom: "5px",
                                    marginLeft: "90px",
                                    width: "200px",
                                    height: "30px",
                                    background: "#303030",

                                }}
                            >
                                <TimeCodeInput
                                    initialValue={tc}
                                    maxFrames={maxframe}
                                    ref= {this.tcref}
                                    onChange = {this.handleOnChangeTc}
                                />
                            </div>

                            <div style={{marginLeft: "90px",fontWeight:"bold", textAlign:"center", fontSize:"12px", textAlign:"left",color:"gray"}}>
                                {this.context.language=="fr"?"Nouveau time code":"New time code"}
                            </div>

                            <div 
                                style={{
                                    marginTop:"10px",
                                    marginBottom: "5px",
                                    marginLeft: "90px",
                                    width: "200px",
                                    height: "30px",
                                    background: "#303030",

                                }}
                            >

                                <TimeCodeInput
                                    initialValue={newtc}
                                    maxFrames={maxframe}
                                    ref= {this.newtcref}
                                    onChange = {this.handleOnChangeNewTc}
                                />

                        </div>

                        <div style={{marginLeft: "90px",fontWeight:"bold", textAlign:"center", fontSize:"12px", textAlign:"left",color:"gray"}}>
                            {this.context.language=="fr"?"Valeur de l'offset":"Offset value"}
                        </div>

                        

                        <div 
                            style={{
                                marginTop:"10px",
                                marginBottom: "5px",
                                marginLeft: "90px",
                                width: "200px",
                                height: "30px",
                                
                                borderWidth: "1px",
                                borderStyle: "solid",
                                borderRadius: "3px",
                                borderColor: "#303030",
                                userSelect: "none",
                                fontFamily: "monospace",
                                fontSize: "16px",
                                paddingTop:"4px",
                                color: this.state.colorOffset,

                            }}>
                                {this.state.libOffset}
                            </div>
                                
                        <div/>
                        
                        </div>

                        <SubtitleSelectionMode ref = {this.selectionModeRef}
                            value="range"
                            onChange={(value) => this.computeOffset()}
                            lineonly = {false}
                            subtitles = {this.props.subtitles} 
                            current = {this.props.current}
                        />                                
                    </div>
                    <div className="submenuBottom">
                        <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} background={false}/>
                    </div>
                </div>
        )

    }

}

Offset.defaultProps = 
{
    subtitles:[],
    current:1,
}

export default Offset;



